import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from "@angular/core";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

import { TemplateService } from "../../service/template.service";

import { TemplateContent } from "../../model/TemplateRulebook";

@Component({
  selector: "app-rulebook-list",
  templateUrl: "./rulebook-list.component.html",
  styleUrls: ["./rulebook-list.component.css"],
  standalone: false,
})
export class RulebookListComponent implements OnInit {
  @Input() rbList: TemplateContent[];
  @Input() selected: string;
  @Input() csskey: number;
  @Output() selectedkey = new EventEmitter<number>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: TemplateService,
    private el: ElementRef
  ) {}

  private scrollActiveIntoView() {
    setTimeout(() => {
      const activeEl = this.el.nativeElement.querySelector('.active');
      if (activeEl) activeEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  ngOnInit() {
    this.service.setKey(parseInt(this.selected));
  }

  // Rulebook names come from the server HTML-encoded (e.g. "&#44;" for a comma).
  decodeHtml(str: string): string {
    return this.service.decodeHtml(str) ?? "";
  }

  onClickRulebook(rbkey: number, rbName: string) {
    this.service.setRbName(rbName);
    this.service.setKey(rbkey);
    this.selectedkey.emit(rbkey);
  }

  onNavigateRulebook(direction: 'next' | 'previous') {
    var values = direction === 'next'
      ? this.service.getNextRbkey()
      : this.service.getPreviousRbkey();
    if (values != null) {
      this.service.setKey(values.first);
      this.service.setRbName(values.second);
      this.selectedkey.emit(values.first);
      this.scrollActiveIntoView();
    }
  }
}
